import React, { Fragment, FunctionComponent } from 'react';
import { Card, Pill } from 'rs-emd-ui-atoms';
import { getLabel } from '../../../..';
import { ILabel } from '../../../../models/common/label.model';
import { IFacet, IFacetValues } from '../../../../models/plp/plp-facets.model';
import { OrderedFilter } from '../filters';
import styles from './applied-filters-component.module.scss';

type AppliedFiltersProps = {
  labels?: ILabel[];
  appliedFilters: IFacet[];
  appliedFlagFilters: IFacetValues[];
  selectedFilters: OrderedFilter[];
  onChangeSelection?: (orderedFilters: OrderedFilter[]) => void;
};

export const AppliedFilters: FunctionComponent<AppliedFiltersProps> = (props: AppliedFiltersProps) => {
  return (
    <Card className={styles['applied-filters-container']}>
      {/* Header */}
      <div className={styles.header}>
        <span className={styles.title}>{`${getLabel(props.labels, 'filters_applied')} (${
          props.appliedFilters.reduce((sum, af) => sum + af.values.length, 0) + props.appliedFlagFilters.length
        })`}</span>
        <button className={`link ${styles.clear}`} onClick={() => props.onChangeSelection && props.onChangeSelection([])}>
          {getLabel(props.labels, 'filters_clear_all')}
        </button>
      </div>

      <div className={styles['facets-container']}>
        {/* Applied Flag Filters */}
        <div className={styles.facets}>
          {props.appliedFlagFilters.map((facet) => {
            return (
              <div className={styles.values}>
                <Pill
                  isClosable={!facet.disabled}
                  isOnClickClosable={!facet.disabled}
                  class={`${styles.pill} ${styles.first}`}
                  closeCallback={() => {
                    props.onChangeSelection && props.onChangeSelection(props.selectedFilters.filter((f) => f.filter.id !== facet.id));
                  }}
                  key={`${facet.id}_${facet.displayValue}`}
                  icon={facet.id === 'flag_better_world' ? 'sustainable' : undefined}
                  label={facet.displayValue}
                />
              </div>
            );
          })}
        </div>

        {/* Applied Filters */}
        <div className={styles.facets} data-testid='applied-filters'>
          {props.appliedFilters.map((facet, appliedFiltersIndex) => {
            return (
              <div className={styles.category} key={facet.id}>
                <div className={styles['cat-header']}>
                  <span data-testid={`applied-filter-name-${appliedFiltersIndex}`}>{facet.displayName}</span>
                  <button
                    className={`link ${styles.clear}`}
                    onClick={() =>
                      props.onChangeSelection && props.onChangeSelection(props.selectedFilters.filter((f) => f.id !== facet.id))
                    }>
                    {`${getLabel(props.labels, 'filters_clear')} (${facet.values.length})`}
                  </button>
                </div>
                <div className={styles.values}>
                  {facet.values.map((facetValue, facetIndex) => {
                    return (
                      <Fragment key={facetValue.id}>
                        <Pill
                          isClosable={true}
                          isOnClickClosable={true}
                          class={`${styles.pill} ${
                            facetIndex === facet.values.length - 1 && appliedFiltersIndex === props.appliedFilters.length - 1
                              ? styles.last
                              : facetIndex === 0
                              ? styles.first
                              : ''
                          }`}
                          closeCallback={() => {
                            props.onChangeSelection &&
                              props.onChangeSelection(props.selectedFilters.filter((f) => f.filter.id !== facetValue.id));
                          }}
                          key={`${facet.id}_${facetValue.id}`}>
                          <div>
                            <span className={styles.category}>{facet.displayName}:&nbsp;</span>
                            <span data-testid={`applied-filter-value-${appliedFiltersIndex}`}>{facetValue.displayValue}</span>
                          </div>
                        </Pill>
                      </Fragment>
                    );
                  })}
                </div>
              </div>
            );
          })}
          {/** do not show if only disabled filter is applied */}
          {(props.appliedFilters.length > 0 || props.appliedFlagFilters.some((f) => !f.disabled)) && (
            <button className={`link ${styles['clear-bottom']}`} onClick={() => props.onChangeSelection && props.onChangeSelection([])}>
              {getLabel(props.labels, 'filters_clear_all')}
            </button>
          )}
        </div>
      </div>
    </Card>
  );
};
